.add-next-step-container {
    width: 100%;
    height: 61px; /* matches height of start trigger card */
}
